
import { Component, Vue, Watch } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { UserModule } from '@/store/modules/user'
import Breadcrumb from '@/components/Breadcrumb/index.vue'
import Hamburger from '@/components/Hamburger/index.vue'
import { getStatus, getShopOpenConfig, saveShopOpenConfig } from '@/api/users'
import { getStoreInfo, listMyStores } from '@/api/store'
import Cookies from 'js-cookie'
import { debounce, throttle } from '@/utils/common'
import { setNewData, getNewData } from '@/utils/cookies'

// 接口
import { getCountUnread } from '@/api/inform'
import { STORE_CONTEXT_EVENT, StoreContextDetail } from '@/utils/storeContext'
// 个人信息 / 修改密码弹层
import Password from '../components/password.vue'
import Profile from '../components/profile.vue'

@Component({
  name: 'Navbar',
  components: {
    Breadcrumb,
    Hamburger,
    Password,
    Profile,
  },
})
export default class extends Vue {
  private storeId = this.getStoreId
  private restKey: number = 0
  private currentStoreName: string = ''
  private currentStoreIdLoaded: string = ''
  private websocket = null
  private newOrder = ''
  private message = ''
  private audioIsPlaying = false
  private audioPaused = false
  private statusValue = true
  private audioUrl: './../../../assets/preview.mp3'
  private shopShow = false
  private dialogVisible = false
  private status = 1
  private openMode = 0
  private businessOpenTime = '09:00'
  private businessCloseTime = '21:30'
  private dialogFormVisible = false
  private dialogProfileVisible = false
  private ountUnread = 0
  private storeListLoading: boolean = false
  private storeList: any[] = []
  // get ountUnread() {
  //   return Number(getNewData())
  // }
  get sidebar() {
    return AppModule.sidebar
  }

  get device() {
    return AppModule.device.toString()
  }

  getuserInfo() {
    return UserModule.userInfo
  }

  get name() {
    return (UserModule.userInfo as any).name
      ? (UserModule.userInfo as any).name
      : JSON.parse(Cookies.get('user_info') as any).name
  }

  get getStoreId() {
    let storeId = ''
    if (UserModule.storeId) {
      storeId = UserModule.storeId
    } else if ((UserModule.userInfo as any).stores != null) {
      storeId = (UserModule.userInfo as any).stores[0].storeId
    }
    return storeId
  }

  get isStoreLocked() {
    return UserModule.isStoreLocked
  }

  @Watch('$store.state.user.storeId', { immediate: true })
  private async onStoreIdChange(id: string | undefined) {
    const sid = id || ''
    if (!sid) {
      this.currentStoreName = ''
      this.currentStoreIdLoaded = ''
      return
    }
    if (this.currentStoreIdLoaded === sid && this.currentStoreName) {
      return
    }
    try {
      const res: any = await getStoreInfo(sid)
      const body = res.data || {}
      if (String(body.code) === '1' && body.data) {
        this.currentStoreName = body.data.storeName || ''
        this.currentStoreIdLoaded = sid
      } else {
        this.currentStoreName = ''
        this.currentStoreIdLoaded = ''
      }
    } catch (_) {
      this.currentStoreName = ''
      this.currentStoreIdLoaded = ''
    }
    await this.refreshShopStatus()
  }

  private onStoreContextChanged = (e: Event) => {
    const detail = ((e as CustomEvent).detail || {}) as StoreContextDetail
    const sid = this.getStoreId
    if (!sid) {
      this.currentStoreName = ''
      this.currentStoreIdLoaded = ''
      return
    }
    if (detail.storeName && detail.storeId != null && String(detail.storeId) === sid) {
      this.currentStoreName = detail.storeName
      this.currentStoreIdLoaded = sid
      this.refreshShopStatus()
      return
    }
    this.currentStoreIdLoaded = ''
    this.onStoreIdChange(sid)
  }

  private async onSwitchVisibleChange(visible: boolean) {
    if (!visible) return
    await this.fetchMyStores()
  }

  private async fetchMyStores() {
    if (this.storeListLoading) return
    this.storeListLoading = true
    try {
      const res: any = await listMyStores()
      const body = res.data || {}
      if (String(body.code) === '1' && Array.isArray(body.data)) {
        this.storeList = body.data
      } else {
        this.storeList = []
      }
    } catch (_) {
      this.storeList = []
    } finally {
      this.storeListLoading = false
    }
  }

  private async handleSwitchCommand(command: string) {
    if (typeof command === 'string' && command.startsWith('store:')) {
      const id = command.split(':')[1]
      if (!id) return
      await UserModule.SetStore(String(id))
      await this.getStatus()
      this.$message.success('商户切换成功')
      // 通过刷新保证各页面按新商户重新拉取数据
      if (this.$route.path === '/store') {
        this.$router.push('/dashboard').catch(() => {})
      }
      setTimeout(() => {
        window.location.reload()
      }, 50)
    }
  }
  mounted() {
    document.addEventListener('click', this.handleClose)
    window.addEventListener('shop-status-changed', this.onShopStatusChanged)
    window.addEventListener(STORE_CONTEXT_EVENT, this.onStoreContextChanged)
    //console.log(this.$store.state.app.statusNumber)
    // const msg = {
    //   data: {
    //     type: 2,
    //     content: '订单1653904906519客户催单，已下单23分钟，仍未接单。',
    //     details: '434'
    //   }
    // }
    this.getStatus()
  }
  created() {
    this.webSocket()
  }
  onload() {
  }
  destroyed() {
    window.removeEventListener('shop-status-changed', this.onShopStatusChanged)
    window.removeEventListener(STORE_CONTEXT_EVENT, this.onStoreContextChanged)
    if (this.websocket) {
      this.websocket.close()
      this.websocket = null
    }
  }

  private onShopStatusChanged = () => {
    this.refreshShopStatus()
  }

  // 添加新订单提示弹窗（按当前店铺隔离：sid=storeId_clientId）
  webSocket() {
    const that = this as any
    if (this.websocket) {
      try {
        this.websocket.close()
      } catch (_) {
        /* ignore */
      }
      this.websocket = null
    }
    const storeId = String(this.getStoreId || '').trim()
    if (!storeId) {
      console.warn('未选择店铺，暂不连接来单提醒 WebSocket')
      return
    }
    let clientId = Math.random().toString(36).substr(2)
    let socketUrl = process.env.VUE_APP_SOCKET_URL + `${storeId}_${clientId}`
    console.log(socketUrl, 'socketUrl')
    if (typeof WebSocket == 'undefined') {
      that.$notify({
        title: '提示',
        message: '当前浏览器无法接收实时报警信息，请使用谷歌浏览器！',
        type: 'warning',
        duration: 0,
      })
    } else {
      this.websocket = new WebSocket(socketUrl)
      // 监听socket打开
      this.websocket.onopen = function () {
        console.log('浏览器WebSocket已打开 storeId=', storeId)
      }
      // 监听socket消息接收
      this.websocket.onmessage = function (msg) {
        let jsonMsg: any
        try {
          jsonMsg = typeof msg.data === 'string' ? JSON.parse(msg.data) : msg.data
        } catch (_) {
          console.log('WebSocket 非 JSON 消息:', msg.data)
          return
        }
        // type=0 为服务端心跳 ping，不能当成催单弹窗
        if (!jsonMsg || jsonMsg.type == null || Number(jsonMsg.type) === 0) {
          return
        }
        // 仅处理当前店铺的来单/催单/退桶等提醒，避免 A 店收到 B 店通知
        const msgStoreId = jsonMsg.storeId != null ? String(jsonMsg.storeId) : ''
        const currentStoreId = String(that.getStoreId || '').trim()
        if (msgStoreId && currentStoreId && msgStoreId !== currentStoreId) {
          return
        }
        const msgType = Number(jsonMsg.type)
        if (msgType !== 1 && msgType !== 6 && msgType !== 7) {
          return
        }

        if (msgType === 1 && that.$refs.audioVo) {
          that.$refs.audioVo.currentTime = 0
          const p = that.$refs.audioVo.play()
          if (p && typeof p.catch === 'function') {
            p.catch(() => {})
          }
        }

        const titleMap: any = {
          1: '待接单',
          6: '退桶退押金',
          7: '押金到期',
        }
        that.getCountUnread()
        that.$notify({
          title: titleMap[msgType] || '通知',
          duration: 0,
          dangerouslyUseHTMLString: true,
          onClick: () => {
            if (msgType === 6) {
              const m = (jsonMsg.content || '').match(/订单号[：:]\s*(\S+)/)
              const query: any = { status: '0' }
              if (m && m[1]) query.orderNumber = m[1]
              that.$router
                .push({ path: '/emptyBucketRefund', query })
                .catch((err) => {
                  console.log(err)
                })
              return
            }
            that.$router
              .push(`/order?orderId=${jsonMsg.orderId}`)
              .catch((err) => {
                console.log(err)
              })
            setTimeout(() => {
              location.reload()
            }, 100)
          },
          message: `${
            msgType === 1
              ? `<span>您有1个<span style=color:#419EFF>订单待处理</span>,${jsonMsg.content},请及时接单</span>`
              : msgType === 6
              ? `<span>${jsonMsg.content} <span style='color:#419EFF;cursor: pointer'>去处理</span></span>`
              : msgType === 7
              ? `<span>空桶押金将满一年，${jsonMsg.content} <span style='color:#419EFF;cursor: pointer'>去查看</span></span>`
              : `${jsonMsg.content}<span style='color:#419EFF;cursor: pointer'>去处理</span>`
          }`,
        })
      }
      // 监听socket错误
      this.websocket.onerror = function () {
        that.$notify({
          title: '错误',
          message: '服务器错误，无法接收实时报警信息',
          type: 'error',
          duration: 0,
        })
      }
      // 监听socket关闭
      this.websocket.onclose = function () {
        console.log('WebSocket已关闭')
      }
    }
  }

  private toggleSideBar() {
    AppModule.ToggleSideBar(false)
  }
  // 退出
  private async logout() {
    try {
      await UserModule.LogOut()
    } catch (_) {
      /* 接口失败也清本地会话 */
    }
    this.$router.replace({ path: '/login' }).catch(() => {})
  }

  private handleAccountCommand(command: string) {
    if (command === 'profile') {
      this.handleProfile()
    } else if (command === 'password') {
      this.handlePwd()
    } else if (command === 'logout') {
      this.logout()
    }
  }

  // 获取未读消息
  async getCountUnread() {
    const { data } = await getCountUnread()
    if (data.code === 1) {
      // this.ountUnread = data.data
      AppModule.StatusNumber(data.data)
      // setNewData(data.data)
      // this.$message.success('操作成功！')
    } else {
      this.$message.error(data.msg)
    }
  }
  // 营业状态（与当前商户 store 时段/模式联动）
  async refreshShopStatus() {
    const storeId = this.getStoreId
    if (!storeId) {
      this.status = 1
      this.openMode = 0
      this.businessOpenTime = '09:00'
      this.businessCloseTime = '21:30'
      return
    }
    try {
      const { data } = await getShopOpenConfig({ storeId })
      if (data && String(data.code) === '1' && data.data) {
        const cfg = data.data
        this.status = cfg.status === 0 ? 0 : 1
        this.openMode = cfg.openMode != null ? Number(cfg.openMode) : 0
        this.businessOpenTime = this.normalizeTime(cfg.businessOpenTime) || '09:00'
        this.businessCloseTime = this.normalizeTime(cfg.businessCloseTime) || '21:30'
        return
      }
      const st = await getStatus({ storeId })
      const s = st.data && st.data.data
      this.status = s === 0 ? 0 : 1
    } catch (_) {
      this.status = 1
      this.openMode = 0
    }
  }
  private normalizeTime(v: any): string {
    if (v == null || v === '') return ''
    const s = String(v)
    return s.length >= 5 ? s.slice(0, 5) : s
  }
  async getStatus() {
    await this.refreshShopStatus()
  }
  // 下拉菜单显示
  toggleShow() {
    this.shopShow = true
  }
  // 下拉菜单隐藏
  mouseLeaves() {
    this.shopShow = false
  }
  // 触发空白处下来菜单关闭
  handleClose() {
    // clearTimeout(this.leave)
    // this.shopShow = false
  }
  // 设置营业状态
  handleStatus() {
    this.refreshShopStatus()
    this.dialogVisible = true
  }
  // 营业状态设置
  async handleSave() {
    const storeId = this.getStoreId
    if (!storeId) {
      this.$message.warning('请先选择商户')
      return
    }
    if (!this.businessOpenTime || !this.businessCloseTime) {
      this.$message.warning('请设置营业开始与结束时间')
      return
    }
    const { data } = await saveShopOpenConfig({
      storeId,
      openMode: Number(this.openMode),
      businessOpenTime: this.businessOpenTime,
      businessCloseTime: this.businessCloseTime,
    })
    if (data.code === 1) {
      this.dialogVisible = false
      this.$message.success('营业状态已保存')
      this.refreshShopStatus()
    } else if (data.msg) {
      this.$message.error(data.msg)
    }
  }
  // 个人信息
  handleProfile() {
    this.dialogProfileVisible = true
  }
  handleProfileClose() {
    this.dialogProfileVisible = false
  }
  // 修改密码
  handlePwd() {
    this.dialogFormVisible = true
  }
  // 关闭密码编辑弹层
  handlePwdClose() {
    this.dialogFormVisible = false
  }
}
